<div class="flex items-center justify-between gap-3 rounded-xl border border-gray-100 bg-gray-50/50 px-4 py-3">
  <div class="min-w-0 flex-1">
    <div class="flex flex-wrap items-center gap-2">
      <span class="text-sm font-semibold text-gray-900">
        {{ contract.validFrom | dayKey }} – {{ contract.validTo | dayKey }}
      </span>
      @if (badge) {
        <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
              [ngClass]="badgeClass">{{ badge }}</span>
      }
    </div>
    <div class="mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-gray-500">
      <span>Shards: <span class="font-medium text-gray-700">{{ contract.shardCount }}</span></span>
      <span>Geräte: <span class="font-medium text-gray-700">{{ contract.deviceCount }}</span></span>
      <span>Monate: <span class="font-medium text-gray-700">{{ contract.minimalMonthsPerDevice }}</span></span>
      <!-- #664: `-1` is "unbegrenzt" and renders as ∞ here too, so one row never reads `-1` while the summary
           card two screens over reads ∞ for the same contract. -->
      <span>Virtuelle Events:
        <span class="font-medium text-gray-700">
          {{ contract.virtualEventCount == -1 ? "&infin;" : contract.virtualEventCount }}
        </span>
      </span>
    </div>
  </div>
  @if (canEdit) {
    <button type="button" (click)="e()" aria-label="Vertrag bearbeiten"
            class="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl text-gray-400
                   transition-all duration-200 hover:bg-gray-100 hover:text-gray-700 active:scale-95">
      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M2.695 14.762l-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z"/>
      </svg>
    </button>
  }
</div>
